import { createFileRoute, notFound } from "@tanstack/react-router";

import { ComparisonPage } from "@/components/marketing/comparison-page";
import { NotFoundPage } from "@/components/marketing/not-found-page";
import { comparisonHead } from "@/lib/seo";

/**
 * Comparison copy comes from the loader rather than a module-scope import, so
 * it does not ride along in the app's entry chunk. See `help.$slug`.
 */
export const Route = createFileRoute("/(public)/alternatives/$competitor")({
  loader: async ({ params }) => {
    const { getComparison } = await import(
      "@/components/marketing/comparison-data"
    );
    const comparison = getComparison(params.competitor);

    if (!comparison) {
      throw notFound();
    }

    return { comparison };
  },
  head: ({ loaderData }) =>
    loaderData?.comparison ? comparisonHead(loaderData.comparison) : {},
  notFoundComponent: NotFoundPage,
  component: ComparisonRoute,
});

function ComparisonRoute() {
  const { comparison } = Route.useLoaderData();
  return <ComparisonPage comparison={comparison} />;
}
